import { render, staticRenderFns } from "./agent_lists.vue?vue&type=template&id=4ffc283b&scoped=true&"
import script from "./agent_lists.vue?vue&type=script&lang=js&"
export * from "./agent_lists.vue?vue&type=script&lang=js&"
import style0 from "./agent_lists.vue?vue&type=style&index=0&id=4ffc283b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffc283b",
  null
  
)

export default component.exports